import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
import { VariantPackDetailedCostChangeDataFieldsFragmentDoc } from './variant-pack-cost-change-data-fragments.generated';
const defaultOptions = {} as const;

export const PricingVariantPackDetailedCostChangeDataDocument = gql`
  query PricingVariantPackDetailedCostChangeData(
    $supplierUUID: uuid
    $variantPackUUID: uuid!
  ) {
    getVariantPackDetailedCostChangeData(
      supplier_id: $supplierUUID
      variant_pack_id: $variantPackUUID
    ) {
      ...VariantPackDetailedCostChangeDataFields
    }
  }
  ${VariantPackDetailedCostChangeDataFieldsFragmentDoc}
`;
export function usePricingVariantPackDetailedCostChangeDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >(PricingVariantPackDetailedCostChangeDataDocument, options);
}
export function usePricingVariantPackDetailedCostChangeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >(PricingVariantPackDetailedCostChangeDataDocument, options);
}
export type PricingVariantPackDetailedCostChangeDataQueryHookResult =
  ReturnType<typeof usePricingVariantPackDetailedCostChangeDataQuery>;
export type PricingVariantPackDetailedCostChangeDataLazyQueryHookResult =
  ReturnType<typeof usePricingVariantPackDetailedCostChangeDataLazyQuery>;
export type PricingVariantPackDetailedCostChangeDataQueryResult =
  Apollo.QueryResult<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >;

/**
 * Wrapped version of useGeneratedPricingVariantPackDetailedCostChangeDataQuery using Pepper's useWrappedQuery
 */
export function useGeneratedPricingVariantPackDetailedCostChangeDataQuery(
  options?: Apollo.QueryHookOptions<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >(PricingVariantPackDetailedCostChangeDataDocument, options);
}

/**
 * Wrapped version of useGeneratedPricingVariantPackDetailedCostChangeDataLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedPricingVariantPackDetailedCostChangeDataLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.PricingVariantPackDetailedCostChangeDataQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.PricingVariantPackDetailedCostChangeDataQuery,
    Types.PricingVariantPackDetailedCostChangeDataQueryVariables
  >(PricingVariantPackDetailedCostChangeDataDocument, lazyOptions);
}
